import ReporteBase from "./ReportePage.js";

const ReporteTiempo = () => {
    return (
        <ReporteBase
            titulo="Reporte Tiempo Respuesta"
            variant="TIEMPO"
        />
    );
};

export default ReporteTiempo;
